export const defaultClinicalReportsFilter = { pageNumber:1, pageSize:6 }